/**
 *
 * @param props
 */
export function simulateDiceContract(props) {
    return Object.assign({ diceCount: null, diceMultiplier: null, diceString: null, diceValue: null, fixedValue: null }, props);
}
